import { Component } from '@angular/core';

@Component({
  selector: 'app-sign-up-showcase',
  styleUrls: ['./sign-up-showcase.component.scss'],
  templateUrl: './sign-up-showcase.component.html',
  standalone: false,
})
export class SignUpShowcaseComponent {}
